import React, { useEffect, useState, useRef } from "react";
import { Box, Grid, Pagination, LinearProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SearchBarComponent } from "../../../component/atom";
import { SampleVideoCard } from "../../../component/molecule";
import HeadingComponent from "../../../component/atom/Headings/Heading";
import { Actions } from "../../../core/modules/Actions";
import { connect } from "react-redux";
import _ from "lodash";
import DropDownComponent from "../../../component/atom/Inputs/DropDown";
import { getText, getThumbnailSrc } from "../../../core/Constant";

const WebinarMainScreen = ({
  getWebinar,
  webinarList,
  verifyToken,
  getStdCourseList,
  stdCourseList,
}) => {
  const navigate = useNavigate();
  const [value, setValue] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [newcourseList, setCourseList] = useState([]);
  const [course, setCourse] = useState(() => {
    const sessionSaved = sessionStorage.getItem("selectedCourse");
    if (sessionSaved) return parseInt(sessionSaved, 10);
    const localSaved = localStorage.getItem("firstcourse");
    return localSaved ? parseInt(localSaved, 10) : "";
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const isInitialFetched = useRef(false);

  const fetchWebinars = async ({
    page = 1,
    per_page = rowsPerPage,
    course: selectedCourse = course,
    search = searchValue,
  } = {}) => {
    if (!selectedCourse) {
      setValue([]);
      setTotalPages(1);
      return;
    }

    setLoading(true);
    await getWebinar({
      course: selectedCourse,
      page,
      per_page,
      search,
    });
    setLoading(false);
  };

  const handlePageChange = (_, value) => {
    setCurrentPage(value);
    fetchWebinars({
      page: value,
      per_page: rowsPerPage,
      course,
      search: searchValue,
    });
  };

  const searchInput = (newvalue) => {
    setSearchValue(newvalue);
    setCurrentPage(1);
    fetchWebinars({
      page: 1,
      per_page: rowsPerPage,
      course,
      search: newvalue,
    });
  };

  useEffect(() => {
    getStdCourseList();
  }, []);

  useEffect(() => {
    const list = _.map(stdCourseList, (item) => ({
      id: parseInt(item.course_id, 10),
      course_id: parseInt(item.course_id, 10),
      name: item.course_name,
    }));
    setCourseList(list);

    if (!list.length) {
      setCourse("");
      setValue([]);
      return;
    }

    const sessionCourse = sessionStorage.getItem("selectedCourse");
    let activeCourseId = sessionCourse ? parseInt(sessionCourse, 10) : course;

    if (sessionCourse) {
      sessionStorage.removeItem("selectedCourse");
    }

    if (!activeCourseId) {
      const localSaved = localStorage.getItem("firstcourse");
      activeCourseId = localSaved ? parseInt(localSaved, 10) : "";
    }

    const matchedCourse = list.find((c) => c.id === activeCourseId)?.id;
    const validCourse = matchedCourse || '';

    if (validCourse) {
      setCourse(validCourse);
      localStorage.setItem("firstcourse", validCourse.toString());

      if (!isInitialFetched.current || course !== validCourse) {
        isInitialFetched.current = true;
    fetchWebinars({
      page: 1,
      per_page: rowsPerPage,
      course: validCourse,
      search: searchValue,
    });
      }
    } else {
      setCourse("");
      setValue([]);
    }
  }, [stdCourseList]);

  useEffect(() => {
    if (!course) {
      setValue([]);
      return;
    }

    const responseItems = _.get(webinarList, "data", webinarList);
    const items = Array.isArray(responseItems)
      ? responseItems
      : _.get(responseItems, "data", []);
    const grouped = _.values(_.groupBy(items, "week"));

    setValue(grouped);

    const total = _.get(webinarList, "total", items.length);
    const perPageFromApi = _.get(webinarList, "per_page", rowsPerPage);

    setTotalItems(total);
    setRowsPerPage(perPageFromApi);

    if (total && perPageFromApi) {
      setTotalPages(Math.ceil(total / perPageFromApi));
    } else if (_.get(webinarList, "last_page")) {
      setTotalPages(webinarList.last_page);
    } else {
      setTotalPages(Math.max(1, Math.ceil(items.length / rowsPerPage)));
    }
  }, [webinarList, course]);

  const onCourseChange = (e) => {
    const Selectedvalue = parseInt(getText(e), 10);
    
    if (!Selectedvalue || isNaN(Selectedvalue)) {
      setCourse("");
      setValue([]);
      localStorage.removeItem("firstcourse");
      sessionStorage.removeItem("selectedCourse");
      return;
    }

    setCourse(Selectedvalue);
    localStorage.setItem("firstcourse", Selectedvalue.toString());
    sessionStorage.setItem("selectedCourse", Selectedvalue.toString());
    setCurrentPage(1);
    fetchWebinars({
      page: 1,
      per_page: rowsPerPage,
      course: Selectedvalue,
      search: searchValue,
    });
  };

  const onViewVideo = (item) => {
    if (course) {
      sessionStorage.setItem("selectedCourse", course.toString());
    }
    navigate("/course-video", { state: { course: item } });
  };

  return (
    <>
      <Grid className="main-screen-container" container flexDirection={"column"} rowSpacing={1} mt={2}>
        <Grid item>
          <Grid container justifyContent={"space-between"}>
            <Grid item>
              <HeadingComponent
                text={"Webinar Archive"}
                size={"26px"}
                color={"#2d3945"}
                fontfamily={"Montserrat"}
                fontweigth={600}
              />
            </Grid>
            <Grid item>
              <Grid container alignItems={"center"}>
                <Grid item>
                  <DropDownComponent
                    isShowPlaceholder={true}
                    isShowZero={false}
                    initialValue="Select Course"
                    onchange={onCourseChange}
                    radius={"15px"}
                    list={newcourseList}
                    selectedValue={course}
                    fixedWidth="100%"
                  />
                </Grid>
                <Grid item>
                  <SearchBarComponent
                    value={searchValue}
                    onchange={(e) => searchInput(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          {loading ? (
            <Box sx={{ width: '100%', mt: 2 }}><LinearProgress /></Box>
          ) : !course ? (
            <Box mt={5} textAlign="center">
              <Typography variant="h6" color="textSecondary">
                Please enroll any course to view webinars.
              </Typography>
            </Box>
          ) : (
            <>
              <Grid container flexDirection={"column"} >
                {value.map((item, index) => {
                  const week = item[0]?.week;
                  return (
                    <Grid item xs={12} key={week || index}>
                      <Box mb={3}>
                        <p className="week-text">{week}</p>
                      </Box>
                      <Grid container spacing={3}>
                        {item?.map((value, count) => {
                          const videoThumbnail = getThumbnailSrc(value?.thumbnail, "video_thumbnail");
                          const hasDay = value?.day !== null && value?.day !== undefined && Number(value?.day) !== 0;    
                          return (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={value.id || count}>
                              <SampleVideoCard
                                onViewVideo={() => onViewVideo(value)}
                                thumbnail={videoThumbnail}
                                videoUrl={value?.content_link}
                                description={
                                  hasDay
                                    ? `${value?.week} - Day ${value?.day}`
                                    : `${value?.week}`
                                }
                                btnText={"Watch"}
                                title={value?.content}
                              />
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Grid>
                  );
                })}
                {/* Pagination Controls */}
                {totalPages > 1 && (
                  <Box mt={3} display="flex" justifyContent="center">
                    <Pagination
                      count={totalPages}
                      page={currentPage}
                      onChange={handlePageChange}
                      color="primary"
                      shape="rounded"
                      showFirstButton
                      showLastButton
                    />
                  </Box>
                )}
              </Grid>
            </>
          )}
        </Grid>

      </Grid>
    </>
  );
};

export default connect(
  (state) => ({
    webinarList: state.webinar.get("webinarList"),
    stdCourseList: state.course.get("stdCourseList"),
  }),
  {
    getWebinar: Actions.webinar.getWebinar,
    verifyToken: Actions.auth.verifyToken,
    getStdCourseList: Actions.course.getStdCourseList,
  }
)(WebinarMainScreen);
